export enum PanelType {
	Front = 'front',
	Back = 'back',
	Left = 'left',
	Right = 'right',
	BackLeft = 'back-left',
	BackRight = 'back-right',
	Countertop = 'countertop',
	Railing = 'railing',
	Column = 'column'
}
